import { createFileRoute } from '@tanstack/react-router';
import { SearchScreen } from '@/features/search/SearchScreen.tsx';

export const Route = createFileRoute('/_app/search')({
  validateSearch: (s: Record<string, unknown>): { q?: string } => (typeof s.q === 'string' ? { q: s.q } : {}),
  component: SearchRoute,
});

function SearchRoute() {
  const { q } = Route.useSearch();
  return <SearchScreen initial={q ?? ''} />;
}
